import { render, staticRenderFns } from "./NotificationCentre.vue?vue&type=template&id=16ec6228&scoped=true"
import script from "./NotificationCentre.vue?vue&type=script&lang=js"
export * from "./NotificationCentre.vue?vue&type=script&lang=js"
import style0 from "./NotificationCentre.vue?vue&type=style&index=0&id=16ec6228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec6228",
  null
  
)

export default component.exports